/**
* 用户管理 用户列表
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理</el-breadcrumb-item>
            <!-- :to="{ path: '/' }" -->
            <el-breadcrumb-item>管理员常见问题设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <div style="float: right;margin-right:2%;">
            <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary" icon="document"
                @click="dataSelect">刷新</el-button>
            <el-button style='margin: 10px 0;' size="mini" type="primary" icon="document"
                @click="addNotice">新增</el-button>
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
        </div>

        <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
            @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" prop="issue" label="问题">
            </el-table-column>
            <el-table-column align="center" prop="content" label="内容">
                <template slot-scope="scope">
                    <div v-html="scope.row.content"></div>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="180px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="updates(scope.$index, scope.row)">修改
                    </el-button>
                    <el-button size="mini" type="danger" @click="deletes(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="添加管理员常见问题" :visible.sync="dialogFormVisible" center>
            <div style="margin-bottom: 10px;">
                <span style="width: 200px;display: inline-block;text-align: right;">问题：</span>
                <el-input style="width:50%;" v-model="addForm.issue" placeholder="请输入价格"></el-input>
            </div>

            <div style="margin-bottom: 10px;">
                <span style="width: 200px;display: inline-block;text-align: right;">内容：</span>
                <!-- <el-input style="width:50%;" v-model="addForm.content" placeholder="请输入每个月免费次数"></el-input> -->
                <quill-editor ref="myTextEditor" v-model="addForm.content" :options="quillOption"
                    style="padding-bottom: 50px;height: 300px;width: 72%;display: inline-table;margin-bottom: 60px;">
                </quill-editor>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="releasNoticeTo()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改管理员常见问题" :visible.sync="dialogFormVisible1" center>
            <div style="margin-bottom: 10px;">
                <span style="width: 200px;display: inline-block;text-align: right;">问题：</span>
                <el-input style="width:50%;" v-model="updateForm.issue" placeholder="请输入价格"></el-input>
            </div>
            <div style="margin-bottom: 10px;">
                <span style="width: 200px;display: inline-block;text-align: right;">内容：</span>
                <!-- <el-input style="width:50%;" v-model="addForm.content" placeholder="请输入每个月免费次数"></el-input> -->
                <quill-editor ref="myTextEditor" v-model="updateForm.content" :options="quillOption"
                    style="padding-bottom: 50px;height: 300px;width: 72%;display: inline-table;margin-bottom: 60px;">
                </quill-editor>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="updateUpTo()">修 改</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import { getFagList, deleteFag, addFag, updateFag } from '../../../api/manage/fag.js'
import moment from 'moment';

export default {
    data() {
        return {
            multipleSelection: [],
            totalnum: 0,
            page: 1,
            size: 10,
            tableDataLoading: false,
            dialogFormVisible: false,
            dialogFormVisible1: false,
            tableData: [],
            addForm: {
                issue: '',
                content: '',
            },
            updateForm: {
                id: '',
                issue: '',
                content: '',
                createTime: '',
                updateTime: '',
            },

        }
    },
    components: {

    },

    created() {
        this.dataSelect()
        // this.getdata(1)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        updates(index, row) {
            this.updateForm = row
            this.dialogFormVisible1 = true
        },

        releasNoticeTo() {
            let post = this.addForm;
            addFag(post).then((res) => {
                this.dialogFormVisible = false
                this.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1500,
                    onClose: () => {
                        this.dataSelect()
                    }
                });
            })
        },

        updateUpTo() {
            let post = this.updateForm;
            updateFag(post).then((res) => {
                this.dialogFormVisible1 = false
                if (res.code == 200) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                        duration: 1500,
                        onClose: () => {
                            this.dataSelect()
                        }
                    });
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })
        },

        deletes(id) {
            let obj = {
                id: id,
            }
            this.$confirm(`确定删除此条信息?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteFag(obj).then(res => {
                    this.$message({
                        type: "success",
                        message: res.msg,
                        duration: 1500,
                        onClose: () => {
                            this.dataSelect()
                        }
                    });
                })
            }).catch(() => { })
        },

        dataSelect() {
            let post = {
                page: (this.page - 1) * this.size,
                size: this.size
            }
            this.tableDataLoading = true
            getFagList(post).then((res) => {
                this.tableDataLoading = false
                if (res.code == 200) {
                    // this.tableData = res.data.data;
                    this.tableData = res.data.data
                    // console.log('this.tableDatathis.tableData',this.tableData)
                    this.totalnum = res.data.count;
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })

        },

        // 添加分类弹框
        addNotice() {
            this.addForm = ''
            this.dialogFormVisible = true
        },

    }
}
</script>

<style scoped>
.userRole {
    width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/fag/index.vue